export const BANNER_IMAGE = 'BANNER_IMAGE';
export const LEAGUE_NAME = 'LEAGUE_NAME';
export const LOGO_IMAGE = 'LOGO_IMAGE';
export const TAGLINE = 'TAGLINE';
export const TEAM_CLASS = 'TEAM_CLASS';
export const TEAM_COLOR = 'TEAM_COLOR';
export const TEAM_NAME = 'TEAM_NAME';
